export const APP_ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  DASHBOARD: '/dashboard',
  HOME: '/',
  CHAT: '/chat',
  Hibro: '/hibro',
  HiCRM: '/hiCRM',
  Unified: '/unified',
};
